angular.module("UI8.controllers").controller("DesignDnaController", [
  "$scope",
  "$http",
  "$timeout",
  "$q",
  function ($scope, $http, $timeout, $q) {
    // ===== Tab =====
    $scope.dnaTab = "cursor";

    $scope.setDnaTab = function (tab) {
      $scope.dnaTab = tab;
    };

    // ===== DNA fetch + state =====
    $scope.dnaCopied = false;
    $scope.dnaProcessing = false;
    $scope.dnaProcessingText = "";
    $scope.dnaContent = null; // full DNA text (with header), fetched on first open

    function fetchDna() {
      $scope.dnaProcessing = true;
      $scope.dnaProcessingText = "Analyzing files...";

      var steps = ["Extracting DNA...", "Cleaning up..."];
      var delays = [
        (Math.random() * 1 + 1) * 1000,
        (Math.random() * 2 + 2) * 1000,
      ];

      steps.forEach(function (text, i) {
        $timeout(function () {
          if ($scope.dnaProcessing) $scope.dnaProcessingText = text;
        }, delays[i]);
      });

      var animationDone = $timeout(delays[delays.length - 1] + 1000);
      var httpDone = $http.get("/api/products/" + $scope.product.slug + "/dna");

      $q.all([animationDone, httpDone]).then(
        function (results) {
          var res = results[1];
          $scope.dnaContent = res.data.designDna || "";
          $scope.dnaPreview = $scope.dnaContent
            .split("\n")
            .slice(0, 18)
            .join("\n");
          $scope.dnaProcessing = false;
        },
        function () {
          $scope.dnaContent = "";
          $scope.dnaProcessing = false;
        }
      );
    }

    var dnaModalHandler = function (_e, isOpen) {
      if (isOpen) {
        $scope.$apply(function () {
          $scope.dnaCopied = false;
          if (!$scope.dnaContent) {
            fetchDna();
          }
        });
      }
    };
    $(document).on("dna-modal", dnaModalHandler);
    $scope.$on("$destroy", function () {
      $(document).off("dna-modal", dnaModalHandler);
    });

    function trackDnaEvent(action) {
      $http
        .post("/api/" + action, {
          productId: $scope.product._id,
          authorId: $scope.product.author && $scope.product.author._id,
          tool: $scope.dnaTab,
        })
        .catch(angular.noop);
    }

    $scope.copyDna = function () {
      if (!$scope.dnaContent || $scope.dnaProcessing) return;

      navigator.clipboard.writeText($scope.dnaContent).then(function () {
        trackDnaEvent("dna-copy");
        $scope.$apply(function () {
          $scope.dnaCopied = true;
        });
        $timeout(function () {
          $scope.dnaCopied = false;
        }, 2000);
      });
    };

    $scope.downloadDna = function () {
      if (!$scope.dnaContent || $scope.dnaProcessing) return;

      trackDnaEvent("dna-download");

      var blob = new Blob([$scope.dnaContent], { type: "text/plain" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "DNA - " + $scope.product.name + ".md";
      a.click();
    };

    // ===== MCP Waitlist =====
    $scope.waitlistEmail = "";
    $scope.waitlistPending = false;
    $scope.waitlistSubmitted = false;
    $scope.waitlistEmailError = false;
    $scope.waitlistDuplicateError = false;

    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    $scope.isValidEmail = function (email) {
      return email && emailRe.test(email);
    };

    $scope.joinWaitlist = function () {
      if ($scope.waitlistPending) return;
      if (!$scope.waitlistEmail || !emailRe.test($scope.waitlistEmail)) {
        $scope.waitlistEmailError = true;
        return;
      }

      $scope.waitlistPending = true;

      $http
        .post("/api/newsletter/loops", { email: $scope.waitlistEmail })
        .then(function (res) {
          $scope.waitlistPending = false;
          if (res.data.success) {
            $scope.waitlistSubmitted = true;
          } else if (res.data.message && res.data.message.toLowerCase().indexOf("already") !== -1) {
            $scope.waitlistDuplicateError = true;
          } else {
            $scope.waitlistSubmitted = true;
          }
        })
        .catch(function () {
          $scope.waitlistSubmitted = true;
          $scope.waitlistPending = false;
        });
    };
  },
]);
